module.exports = __webpack_public_path__ + "static/media/HAUX_ENFERMAGEM_2_6.83b982ff.pdf";